import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-adyen-ae-file-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './adyen-ae-file-exporter-configuration.component.html',
  styleUrls: ['./adyen-ae-file-exporter-configuration.component.scss']
})
export class AdyenAccountingEntriesFileExporterConfigurationComponent {
  formGroup: FormGroup;
  constructor(
    readonly fb: FormBuilder
  ) {
    this.formGroup = fb.group({});
  }
}